import React, { Component, Fragment } from 'react';

import { graphql, createRefetchContainer } from 'react-relay';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import { withStyles } from '@material-ui/styles';
import { Grid, Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import { BackgroundImg } from '../../components';
import { useStyles } from './styles.js';
import frontSquareBoxEventDataSubscription from '../../data/subscription/frontSquareBoxEventDataSubscription';

class SquareLeaderboardResult extends Component {
  constructor(props) {
    super(props);
    this.state = {
      board: Array(10).fill(0),
      answers: {},
    };
  }

  componentDidMount() {
    if (this.props.getSquareLeaderboardData.getSquareLeaderboardData.data) {
      this.prepareData(
        this.props.getSquareLeaderboardData.getSquareLeaderboardData.data,
      );

      frontSquareBoxEventDataSubscription(
        {
          event_id: this.props.getSquareLeaderboardData.getSquareLeaderboardData
            .data.event_id,
          current_board_id: this.props.getSquareLeaderboardData
            .getSquareLeaderboardData.data._id,
        },
        response => {
          this._refetch();
        },
        error => console.log('error'),
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.getSquareLeaderboardData.getSquareLeaderboardData.data) {
      this.prepareData(
        nextProps.getSquareLeaderboardData.getSquareLeaderboardData.data,
      );
    }
  }

  prepareData(data) {
    let answers = {};
    data.answers.forEach(answer => {
      answers[answer.square] = answer;
    });
    this.setState({ answers });
  }

  _refetch = () => {
    this.props.relay.refetch(
      {
        event_id: this.props.getSquareLeaderboardData.getSquareLeaderboardData
          .data.event_id,
        current_board_id: this.props.getSquareLeaderboardData
          .getSquareLeaderboardData.data._id,
      },
      null,
      () => {},
      { force: true },
    );
  };

  render() {
    const { classes } = this.props;
    const page_bg_image = this.props.event.page_bg_image;
    const show_page_bg_image = this.props.event.show_page_bg_image;
    return (
      <Grid container>
        <BackgroundImg page_bg_image={page_bg_image} show={show_page_bg_image} />
        <Grid className={classes.innerGrid}>
          <div className={classes.tableScrollable}>
            <div className={classes.squareBoxXAxisLabel}>
              <h4
                style={{
                  border: 0,
                  fontWeight: 'bold',
                  color: this.props.textColor,
                }}
              >
                Home Team{' '}
                {this.props.event && this.props.event.team1
                  ? `(${this.props.event.team1.team_name})`
                  : ''}
              </h4>
            </div>
            <Table className={classes.squareBoxTable}>
              <TableBody>
                <TableRow>
                  <TableCell
                    className={clsx(classes.squareBoxRowVal, 'squareBoxColVal')}
                  >
                    &nbsp;
                  </TableCell>
                  <TableCell
                    className={clsx(classes.squareBoxRowVal, 'squareBoxColVal')}
                  >
                    &nbsp;
                  </TableCell>

                  {this.state.board.map((v, i) => {
                    return (
                      <TableCell
                        key={`squareBoxRowVal_${v}`}
                        className={clsx(
                          classes.squareBoxRowVal,
                          'squareBoxColVal',
                        )}
                        style={{fontWeight: 'bold'}}
                      >
                        {
                          this.props.getSquareLeaderboardData
                            .getSquareLeaderboardData.data.colarr[i]
                        }
                      </TableCell>
                    );
                  })}
                </TableRow>

                {this.state.board.map((v1, i1) => {
                  return (
                    <TableRow
                      key={`squareBoxColVal_${i1}`}
                      className={clsx(classes.squareBoxRow, 'guestBoxs')}
                    >
                      {i1 == 0 && (
                        <TableCell
                          rowSpan={10}
                          className={classes.squareBoxXAxisCell}
                          style={{ borderColor: this.props.buttonTextColor }}
                        ></TableCell>
                      )}
                      <TableCell
                        className={clsx(
                          classes.squareBoxRowVal,
                          'squareBoxColVal',
                        )}
                        style={{ borderColor: this.props.buttonTextColor, fontWeight: 'bold' }}
                      >
                        {
                          this.props.getSquareLeaderboardData
                            .getSquareLeaderboardData.data.rowarr[i1]
                        }
                      </TableCell>

                      {this.state.board.map((v2, i2) => {
                        return (
                          <TableCell
                            className={clsx(classes.squareBox)}
                            key={`squareCol${i2}`}
                            style={{
                              borderColor: this.props.buttonTextColor,
                              color:
                                this.state.answers[i1 + '' + i2] &&
                                this.state.answers[i1 + '' + i2].winner
                                  ? 'white'
                                  : null,
                              backgroundColor:
                                this.state.answers[i1 + '' + i2] &&
                                this.state.answers[i1 + '' + i2].winner
                                  ? this.props.buttonTextColor
                                  : null,
                            }}
                          >
                            {this.state.answers[i1 + '' + i2] &&
                              this.state.answers[i1 + '' + i2].guest_name}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}

                <TableRow>
                  <TableCell style={{ border: 0 }}>&nbsp;</TableCell>
                  <TableCell style={{ border: 0 }}>&nbsp;</TableCell>
                  <TableCell
                    style={{
                      color: this.props.textColor,
                    }}
                    colSpan={10}
                    className={classes.squareBoxYAxisLabel}
                  >
                    <h4
                      style={{
                        border: 0,
                        fontWeight: 'bold',
                        color: this.props.textColor,
                      }}
                    >
                      Away Team{' '}
                      {this.props.event && this.props.event.team2
                        ? `(${this.props.event.team2.team_name})`
                        : ''}
                    </h4>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </div>
        </Grid>
      </Grid>
    );
  }
}

SquareLeaderboardResult.propTypes = {
  className: PropTypes.string,
};

export default createRefetchContainer(
  withStyles(useStyles)(SquareLeaderboardResult),
  {
    getSquareLeaderboardData: graphql`
      fragment SquareLeaderboardResult_getSquareLeaderboardData on Query
        @argumentDefinitions(question_leaderboard_link: { type: "ID!" }) {
        getSquareLeaderboardData(
          question_leaderboard_link: $question_leaderboard_link
        ) {
          code
          message
          data {
            _id
            game_id
            event_id
            leaderboard_link
            rowarr
            colarr
            answers {
              _id
              guest_name
              guest_id
              square
              winner
            }
          }
        }
      }
    `,
  },
  graphql`
    query SquareLeaderboardResultRefetchQuery($question_leaderboard_link: ID!) {
      ...SquareLeaderboardResult_getSquareLeaderboardData
        @arguments(question_leaderboard_link: $question_leaderboard_link)
    }
  `,
);
